module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "access-token-class-components-Items"
  }, [(_vm.device == 'pc') ? _c('div', {
    staticClass: "content pc"
  }, [_c('div', {
    staticClass: "rain-markdown",
    domProps: {
      "innerHTML": _vm._s(_vm.md(_vm.item))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.device == 'pad') ? _c('div', {
    staticClass: "content pad"
  }, [_c('div', {
    staticClass: "rain-markdown",
    domProps: {
      "innerHTML": _vm._s(_vm.md(_vm.item))
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-366c316e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Items/index.vue
// module id = 420
// module chunks = 2